// Centralized favorites cache to reduce API calls and storage
import { GenericCache } from './genericCache';

export interface FavoriteChannel {
  id: string;
  channelId: string;
  position: number;
  channel: {
    id: string;
    name: string;
    description: string | null;
    isVoice: boolean;
    isPrivate: boolean;
  };
}

const FAVORITES_CACHE_KEY = 'favorites_cache';
const FAVORITES_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

class FavoritesCache {
  private cache = new GenericCache<FavoriteChannel[]>({
    key: FAVORITES_CACHE_KEY,
    duration: FAVORITES_CACHE_DURATION,
  });

  get(): FavoriteChannel[] | null {
    return this.cache.get();
  }

  set(data: FavoriteChannel[]): void {
    this.cache.set(data);
  }

  clear(): void {
    this.cache.clear();
  }

  getFavoriteIds(): Set<string> | null {
    const favorites = this.get();
    if (!favorites) return null;
    return new Set<string>(favorites.map((fav) => fav.channelId));
  }
}

export const favoritesCache = new FavoritesCache();
